import React from "react";

import { LayoutGrid } from "lucide-react";

import { ScrollArea } from "@/components/ui/scroll-area";

import PropertySection from "./PropertySection";
import DraggableComponent from "./components/Draggable";
import DraggableSection from "./components/DraggableSection";
import {
  basicComponents,
  layoutComponents,
  sectionComponents,
  navigationComponents,
} from "@/lib/visual-editor/helper";

interface InsertPanelProps {}

export default function InsertPanel(
  _props: InsertPanelProps,
): React.ReactElement {
  return (
    <div className="flex flex-col h-full bg-background overflow-hidden">
      {/* Header */}
      <div className="h-12 px-4 border-b border-border flex items-center gap-2 bg-background shrink-0">
        <LayoutGrid className="w-4 h-4 text-muted-foreground" />
        <span className="text-sm font-medium text-foreground">Insert</span>
      </div>

      {/* Scrollable content */}
      <ScrollArea className="flex-1">
        <div className="p-4 space-y-1">
          <PropertySection
            title="Basic Components"
            defaultOpen
            defaultBorder={false}
          >
            <div className="grid grid-cols-3 gap-2">
              {basicComponents.map((component, idx) => (
                <DraggableComponent key={idx} component={component} />
              ))}
            </div>
          </PropertySection>

          <PropertySection title="Layout" defaultOpen defaultBorder={false}>
            <div className="grid grid-cols-3 gap-2">
              {layoutComponents.map((component) => (
                <DraggableComponent
                  key={component.componentType}
                  component={component}
                />
              ))}
            </div>
          </PropertySection>

          <PropertySection title="Sections" defaultOpen defaultBorder={false}>
            <div className="grid grid-cols-3 gap-2">
              {sectionComponents.map((section) => (
                <DraggableSection
                  key={section.componentType}
                  section={section}
                />
              ))}
            </div>
          </PropertySection>

          <PropertySection title="Navigation" defaultOpen defaultBorder={false}>
            <div className="grid grid-cols-3 gap-2">
              {navigationComponents.map((section) => (
                <DraggableSection
                  key={section.componentType}
                  section={section}
                />
              ))}
            </div>
          </PropertySection>
        </div>
      </ScrollArea>
    </div>
  );
}
